var Handlebars = require("/home/jenkins/agent/workspace/hybrid-accsts-task-release/hybrid-accsts-jsclient/target/toolchain/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"script-views\">\n    <ol class=\"lines script-view\"></ol>\n    <textarea class=\"editor script-view\">"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"script") || (depth0 != null ? lookupProperty(depth0,"script") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"script","hash":{},"data":data,"loc":{"start":{"line":3,"column":41},"end":{"line":3,"column":51}}}) : helper)))
    + "</textarea>\n</div>\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./test/it/lib/templates/script_view.hbs
// module id = 1605
// module chunks = 0